import { EmailLogActions } from '../constants';
import { QueryParams } from 'src/types/grid';

export interface GetEmailsLogsAction {
    type: typeof EmailLogActions.FETCH_EMAILS_LOG;
    payload: QueryParams;
}

export function getEmailsLogs(params: QueryParams): GetEmailsLogsAction {
    return {
        type: EmailLogActions.FETCH_EMAILS_LOG,
        payload: params,
    };
}
export interface ResendEmailLogAction {
    type: typeof EmailLogActions.EMAIL_LOG_RESEND;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function resendEmailLog(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): ResendEmailLogAction {
    return {
        type: EmailLogActions.EMAIL_LOG_RESEND,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetEmailsLogsAction | ResendEmailLogAction;
